import React, { useState } from "react";
import "./Login.css";
import { firebase, cheq, auth, googleProvider, appleProvider } from "./firebaseConfig";
import { BrowserRouter as Link } from "react-router-dom";

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import ClientDetails from "./school_corporate/components/clientDetails";
import FooterNext from "./Footers/FooterNext";

import { Button } from "react-bootstrap";
import ShowBranches from "./components/showBranches";
import ShowExperts from "./components/showExperts";
import ShowMemes from "./components/showMemes";
import { FaGoogle, FaApple } from 'react-icons/fa';
import { Container, Row, Col, Card } from 'react-bootstrap';

import img1 from '/Users/divyashree/Downloads/dr planete web/folder/dr_planete/src/club/images/i4.png';
import newlogo from '/Users/divyashree/Downloads/dr planete web/folder/dr_planete/src/club/images/logonew.png';

import signinicon from './club/images/signinicons.png';
const Login = () => {
  // Inputs
  
  /*
  const [mynumber, setnumber] = useState("");
  const [otp, setotp] = useState("");
  const [show, setshow] = useState(false);
  const [final, setfinal] = useState("");

  // Sent OTP

  const signin = () => {
    if (mynumber === "" || mynumber.length < 10) return;

    let verify = new firebase.auth.RecaptchaVerifier("recaptcha-container");
    cheq
      .signInWithPhoneNumber("+91" + mynumber, verify)
      .then((result) => {
        setfinal(result);
        <div class="alert alert-success" role="alert">
          A simple success alert—check it out!
        </div>;
        //alert("code sent");
        setshow(true);
      })
      .catch((err) => {
        alert(err);
        window.location.reload();
      });
  };

  // Validate OTP
  const ValidateOtp = () => {
    if (otp === null || final === null) return;
    final
      .confirm(otp)
      .then((result) => {
        // success
      })
      .catch((err) => {
        alert("Wrong code");
      });
  };


  */

  const signInWithGoogle = async () => {
    try {
      await auth.signInWithPopup(googleProvider);
    } catch (error) {
      console.error("Error signing in with Google", error);
    }
  };

  const signInWithApple = async () => {
    try {
      await auth.signInWithPopup(appleProvider);
    } catch (error) {
      console.error("Error signing in with Apple", error);
    }
  };

  
  return (
    <div>
    <div className="lgs-container">
      <div className="lgs-left" style={{background:"black"}}>
        <h1 className="lgs-heading">
          Let’s get <span className="lgs-highlight">Started</span>
        </h1>
      </div>


      <div className="lgs-right" style={{background:"transparent", marginTop:"10%"}}>
        <div className="lgs-signin-box">

          <div style={{width:"70%", marginLeft:"15%"}}>
          <img src={signinicon} alt="Doctors" />
          </div>
        <Button
        variant="danger"
        className="d-flex align-items-center justify-content-center w-100 my-5"
        onClick={signInWithGoogle}
      >
        <FaGoogle className="me-2" />
        Sign in with Google
      </Button>
          <p className="lgs-terms">
            By signing in you agree to Terms and Conditions and Privacy Policy
          </p>
        </div>
      </div>

      {/* Inline CSS */}
      <style>{`
        .lgs-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          background-color: black;
          color: #fff;
          min-height: 100vh;
          font-family: "Poppins", sans-serif;
          padding: 40px;
          box-sizing: border-box;
        }

        .lgs-left {
          flex: 1;
          padding: 10px;
          width:60%;
          margin-left:2.5%;
          margin-top:-20%;
        }

        .lgs-heading {
          font-size: 6rem;
          font-weight: 700;
          margin: 0;
          line-height: 1.2;
        }

        .lgs-highlight {
          color: #ff2d87;
          display: block;
          font-size: 10rem;
        }

        .lgs-right {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0px;
          margin-top:-10%;
        }

        .lgs-signin-box {
          background-color:rgb(47, 46, 45);
          border-radius: 32px;
          padding: 40px 30px 20px 30px;
          text-align: center;
          width: 100%;
          max-width: 400px;
          height:25%;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.3);
        }

        .lgs-signin-button {
          background-color: #ff2d87;
          border: none;
          border-radius: 50px;
          padding: 16px 24px;
          font-size: 1.2rem;
          font-weight: bold;
          color: white;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          box-shadow: 0 4px #000;
          width: 100%;
        }

        .lgs-user-icon {
          background-color: white;
          color: #ff2d87;
          border-radius: 50%;
          padding: 6px;
          font-size: 1.4rem;
        }

        .lgs-terms {
          font-size: 0.7rem;
          color: #fff;
          opacity: 0.8;
          margin-top: 12px;
        }

        @media (max-width: 768px) {
          .lgs-container {
            flex-direction: column;
            text-align: left;
          }

          .lgs-left{
              width:100%;
              margin-top:10%;
              height:auto;
          }
          .lgs-heading {
            font-size: 3.5rem;
          }

          .lgs-highlight {
            font-size: 5rem;
          }

          .lgs-right {
            width: 100%;
            margin-left:5%;
            margin-top:-180%;
          }

          .lgs-signin-box {
            width: 90%;
          }
        }
      `}</style>
    </div>
    <FooterNext/>
    </div>
  );
};
    
export default Login;

 {/* <div>
      
      <Container className="my-5">
        

        <Row className="mb-4">

          
          <Col md={6}>
            <img
              className="d-block w-100 mb-3"
              src={img1}
              alt="First section"
              style={{ width: '80%', height: 'auto' }} // Adjust the size if needed
            />
          </Col>
          <Col md={6} className="d-flex flex-column justify-content-center">
            <img
              className="d-block w-100 mb-3"
              src={newlogo}
              alt="First section"
              style={{ width: '40%', border: '2px solid #fff', height: 'auto' }}
            />

            <div>

            <div className="d-flex flex-column align-items-center">

            <Button
        variant="dark"
        className="d-flex align-items-center justify-content-center w-100 my-2"
        onClick={signInWithApple}
      ><FaApple className="me-2" />
      Sign in with Apple
    </Button>
      <Button
        variant="danger"
        className="d-flex align-items-center justify-content-center w-100 my-2"
        onClick={signInWithGoogle}
      >
        <FaGoogle className="me-2" />
        Sign in with Google
      </Button>
      
        
    </div>
            
              
            </div>

            <div>
            </div>
          </Col>
        </Row>

      </Container>
      

    </div>*/}

{/*
    <div className="login-container">

      <center>

        <div class="container" >

          <div className="get-things" style={{opacity:"0"}}>
            <h5><b>Login to get Started!!</b></h5>
            <h5><b>Login to get Started!!</b></h5>
            <h5><b>Login to get Started!!</b></h5><h5><b>Login to get Started!!</b></h5><h5><b>Login to get Started!!</b></h5><h5><b>Login to get Started!!</b></h5><h5><b>Login to get Started!!</b></h5><h5><b>Login to get Started!!</b></h5><h5><b>Login to get Started!!</b></h5><h5><b>Login to get Started!!</b></h5><h5><b>Login to get Started!!</b></h5>
          </div>

          <div className="show-stuff" style={{opacity:"0"}}>
            <h5><b>Login to get Started!!</b></h5>
            <h5><b>Login to get Started!!</b></h5>
            <h5><b>Login to get Started!!</b></h5>
          </div>

          <div>
            <div style={{ display: !show ? "block" : "none" }}>

              <TextField id="outlined-basic" fullWidth label="Phone Number" value={mynumber} onChange={(e) => {
                setnumber(e.target.value);
              }}
                InputProps={{
                  startAdornment: <InputAdornment position="start">+91</InputAdornment>,
                }} variant="outlined" />

              <br />
              <br />
              <div id="recaptcha-container"></div>
              <button
                class="btn btn-success"
                style={{ marginTop: "5px" }}
                onClick={signin}
              >
                Send OTP
              </button>
            </div>
            <div
              class="form-group form-control-lg col-lg-3"
              style={{ display: show ? "block" : "none" }}
            >

              <TextField id="outlined-basic" fullWidth label="Enter OTP"
                onChange={(e) => {
                  setotp(e.target.value);
                }}
                variant="outlined" />
              <br />
              <br />
              <Button variant="primary" onClick={ValidateOtp}>
                Verify
              </Button>
             
            </div>
          </div>

         
        </div>
        
        <div class="show-stuff" style={{marginTop:"250px"}}>

          <div>
            <ShowExperts/>
          </div>

          <div>
            <ShowMemes/>
          </div>

          
        </div>

      </center>
      <div className="show-footer">
      <FooterNext />
      </div>
      
    </div > */}